module.exports = __webpack_public_path__ + "img/D202009_4.7af610b8.jpg";